import { Col, Container, Row } from "reactstrap";
import { BrowseCarService } from "../../../../constants";
import { ServiceData } from "../../../../data/demo/CarDemo1";
import { dynamicImage, Image } from "../../../../utils";
import CommonHeader from "../../../home/common/CommonHeader";

const JPJPage = () => {
  return (
    <section className="job-category-section car-about-category section-b-space">
      <Container>
        <CommonHeader contentClass="text-black" title={"JPJ Services"} content="Enjoy Hassle free services, let us handle the process. We provide door to door services for" headClass="title-style-3 text-center" />
        <Row className="gy-4">
          <Col xl="4" lg="4" sm="6">
              <div className="category-box">
                <Image src={dynamicImage("other/jpj/puspakom.png")} alt="dots-category" className="img-fluid" />
                <div className="category-title">
                  <h4>Puspakom Services</h4>
                </div>
              </div>
            </Col>
          <Col xl="4" lg="4" sm="6">
              <div className="category-box">
                <Image src={dynamicImage("other/jpj/vehicle_transfer.png")} alt="dots-category" className="img-fluid" />
                <div className="category-title">
                  <h4>Vehicle Transfer Ownership</h4>
                </div>
              </div>
            </Col>
          <Col xl="4" lg="4" sm="6">
              <div className="category-box">
                <Image src={dynamicImage("other/jpj/interchange_of_number_plate.jpg")} alt="dots-category" className="img-fluid" />
                <div className="category-title">
                  <h4>Interchange of Number Plate</h4>
                </div>
              </div>
            </Col>
        </Row>
      </Container>
    </section>
  );
};

export default JPJPage;
